import React from 'react';

const AZ = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_202"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_202)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#E3002E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V15H0V10Z"
        fill="#00AF62"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V5H0V0Z"
        fill="#0097C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7H13V8H12V7Z"
        fill="#FBDCE2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 9C12.044 9.607 11.318 10 10.5 10C9.12 10 8 8.88 8 7.5C8 6.12 9.12 5 10.5 5C11.318 5 12.044 5.393 12.5 6H11C10.172 6 9.5 6.672 9.5 7.5C9.5 8.328 10.172 9 11 9H12.5Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default AZ;
